import Cover from '../../components/Cover/Cover';
import './Home.css';
import coverImage from '../../assets/images/mainCoverImage.webp';
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";
import HomeAbout from './HomeAbout/HomeAbout';
import HomeServices from './HomeServices/HomeServices';
import HomeTrademarks from './HomeTrademarks/HomeTrademarks';
import OurClients from './OurClients/OurClients';
import HomeCookTogether from './HomeCookTogether/HomeCookTogether';

const Home = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;

  return (
    <div className='page'>
      <title>
      Головна | ТОВ «Миколаївмолпром» – Pastoral та Мумуля
      </title>
      <meta
        name="description"
        content="Вітання від ТОВ «Миколаївмолпром»! Дізнайтесь про продукцію брендів Pastoral та Мумуля, фірмові магазини, сертифікати якості та новинки молочної продукції."
      />
      <Cover src={coverImageToUse} text={"“Pastoral” -  Французькі традиції"}/>
      <HomeAbout />
      <HomeServices />
      <HomeTrademarks />
      <OurClients />
      <HomeCookTogether />
    </div>
  )
}

export default Home